/**
 * Maps a customStatus string to a Tailwind background-color class for the
 * presence indicator dot. Matches against the StatusBadge PRESETS labels
 * (case-insensitive, emoji-safe).
 */
export function getPresenceDotColor(status: string | null | undefined): string {
  const s = (status ?? "").toLowerCase();
  if (!s) return "bg-muted-foreground";
  if (s.includes("office") || s.includes("working from home")) return "bg-success";
  if (s.includes("break") || s.includes("traveling")) return "bg-warning";
  if (s.includes("meeting") || s.includes("focus")) return "bg-info";
  if (s.includes("busy")) return "bg-danger";
  if (s.includes("leave")) return "bg-violet-500";
  return "bg-success";
}
